import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeactivateGiftCardMutation = createMutationHook(
  GiftCardsApiClient.deactivateGiftCard,
  {
    mutationKey: ['deactivateGiftCard'],
  },
)
